export function Progress({ step, total }) {
  if (step === undefined) return null;

  return <progress className="progress" value={step} max={total} />;
}
